import _startCase from 'lodash/startCase';

export default (string = '') => {
  return _startCase(string);
};
